import { evalTemplate } from "@/services/util";

class API {
  constructor(path) {
    this.path = path;
  }

  getUrl(params) {
    if (typeof params === "string" || typeof params === "number")
      params = { id: params };
    return evalTemplate(this.path, params);
  }
}

export const employeesAPI = new API("/employees");
export const employeeByIdAPI = new API("/employees/${id}");
export const employeeAlertsAPI = new API("/employees/${id}/alerts");
export const employeeIarAPI = new API(
  "/employees/${id}/individual-audit-report"
);
export const employeeAlertByIdAPI = new API(
  "/employees/${employeeId}/alerts/${alertId}"
);
export const employeesUploadAPI = new API("/employees/uploads");
export const employeeMonitorPriceAPI = new API(
  "/employees/monitor-pricing/price-tiers"
);
export const employeeMonitorPriceByIdAPI = new API(
  "/employees/monitor-pricing/price-tiers/${id}"
);

export const statesAPI = new API("/util/states");
export const countriesAPI = new API("/util/countries");
export const braintreeTokenAPI = new API("/braintree/client-token");
export const customersAPI = new API("/customers");
export const customerDetailsAPI = new API("/customers/${customerId}/detail");
export const customerDetailsWithVendorAPI = new API(
  "/customers/${customerId}/detail/${vendorId}"
);

export const paymentMethodAPI = new API("/payment-method");

// checklistitems APIs
export const customerChecklistAPI = new API(
  "/customers/${customerId}/checklist"
);
export const customerSignupChecklistAPI = new API(
  "/customers/${customerId}/signup-checklist/${vendorId}"
);
export const customerChecklistByIdAPI = new API(
  "/customers/${customerId}/checklist/${checklistItemId}?markComplete=${markComplete}"
);
export const customerEvdChecklistByIdAPI = new API(
  "/customers/${customerId}/evdchecklist/${checklistItemId}?markComplete=${markComplete}"
);

export const customerPOMChecklistByIdAPI = new API(
  "/customers/${customerId}/proof-of-monitoring-checklist/${checklistItemId}"
);
export const getPOMFileByChecklistIdAPI = new API(
  "/services/proof-of-monitoring-files/checklist-item/${id}"
);
export const lastChecklistItemAPI = new API(
  "/customers/${id}/last-checklist-item"
);
export const checklistItemAPI = new API("/checklist-items");

export const evdHistoryAPI = new API("/evd-history");

export const vpSubscriptionsAPI = new API("/subscriptions");
export const vpSubscriptionTypesAPI = new API("/subscriptions/types");

export const vendorInfoAPI = new API("/vendor-info");
export const vendorInfoByIdAPI = new API("/vendor-info/${id}");

export const checklistItemConfigurationAPI = new API(
  "/checklist-item-configurations/currentVendor"
);

// account APIs
export const companyAPI = new API("/account/company");
export const marketplaceProfileAPI = new API("/account/marketplace/profile");
export const marketplaceCategoriesAPI = new API(
  "/account/marketplace/categories"
);

export const ownersAPI = new API("/owners");
export const ownerByIdAPI = new API("/owners/${id}");
export const ownershipAPI = new API("/vendor-info/ownership");

export const paymentsAPI = new API("/account/payments");
export const subscriptionsAPI = new API("/account/subscriptions");
export const subscriptionByIdAPI = new API("/account/subscriptions/${id}");
export const usersAPI = new API("/account/users");
export const userByIdAPI = new API("/account/users/${id}");
export const currentUserAPI = new API("/account/users/current");

// w9
export const w9API = new API("/account/w9");
export const w9SubmitAPI = new API("/account/w9/submit");
export const w9DownloadAPI = new API("/account/w9/${id}");

// amplitude
export const analyticAPI = new API("/analytic");

// purl
export const purlPathAPI = new API("/purl${purlPath}");

// files upload
export const fileUploadAPI = new API("/files");

// user notifications
export const userNotificationsByIdAPI = new API("/usernotifications/${id}");
export const userNotificationsAPI = new API("/usernotifications");

// scheduled reports
export const scheduledReportAPI = new API("/scheduled-reports");
export const scheduledReportByIdAPI = new API("/scheduled-reports/${id}");

//vendor signup
export const vendorSignupAPI = new API("/vendor/signup/${id}");
export const vendorCreateAccountAPI = new API("/vendor/signup");

//payment waiver
export const paymentWaiverReasonsAPI = new API("/payment-waiver/reasons");
export const paymentWaiverAPI = new API("/payment-waiver");

//clientconfig
export const clientConfigAPI = new API("/clientconfig/${id}");

//checklistrequest
export const checklistRequestsAPI = new API("/checklistrequests");

//client
export const clientForPurlAPI = new API("/clients/purl/${id}");
export const clientForIdAPI = new API("/clients/id/${id}");
export const subclientsForParentPurlAPI = new API(
  "/clients/purl/${id}/subclients"
);
export const subclientsForParentIdAPI = new API("/clients/id/${id}/subclients");
export const subclientsForSelectedClientAPI = new API(
  "/clients/selected/subclients"
);

export const vendorCategoryAPI = new API("/clients/${id}/vendor-categories");

//simple-cov
export const simpleCovAPI = new API("/simple-cov");

// revision request notes
export const revisionRequestNotesAPI = new API("/revision-request-notes");

// client dashboard
export const clientDashboardAPI = new API("/client/dashboard/all");

// salesforce invoice
export const salesforceInvoiceAPI = new API("/invoice/salesforce-report");
export const invoicesAPI = new API("/invoices");
export const invoiceClientsAPI = new API("/invoices/clients");
export const annualSpendAPI = new API("/invoices/annual-spend/${vendorNumber}");

// import config
export const importConfigAPI = new API("/imports/config/${id}");

// set current vendor
export const currentVendorAPI = new API("/current-vendor");

// get current vendor
export const currentVendorOptionsAPI = new API(
  "/current-vendor/options?text=${text}"
);

// set current client
export const currentClientAPI = new API("/current-client");

// get options for current client
export const currentClientOptionsAPI = new API(
  "/current-client/options?text=${text}"
);
// get options for current client
export const signupCodeAPI = new API("/signup-code/${id}");
export const allSignupCodeAPI = new API("/signup-code/all/${covgId}");
export const validateSignupCodeAPI = new API("/signup-code/${id}/validate");

//User preferences
export const userPreferenceAPI = new API("/user/preferences");
export const userPreferenceByKeyAPI = new API("/user/preferences?key=${key}");

//merge vendors
export const getVendorToMergeAPI = new API(
  "merge-vendor/vendor?covId=${covId}"
);
export const mergeVendorsAPI = new API("merge-vendor/");

//grouping file upload
export const groupingUploadAPI = new API("/grouping/uploads");

//monitor alert bulk resolve file upload
export const monitorAlertBulkResolveAPI = new API("/monitor-alert/uploads");

//enrollment due date file upload
export const enrollmentDueDateUploadAPI = new API("/enrollment-due-date");

export const trackedJobsAPI = new API("/jobs");
export const eligibilityAuditAPI = new API("/eligibility/audit");

//onboarding apis
export const workflowsAPI = new API("/onboarding/workflows");
export const templateWorkflowSteps = new API(
  "/onboarding/template-workflow/steps"
);
export const workflowStepsAPI = new API("/onboarding/steps/${covgId}");
export const workflowStepAPI = new API("/onboarding/step/${id}");
export const workflowStepStatusUpdateAPI = new API(
  "/onboarding/step/status-update"
);
export const workflowVendorSummaryAPI = new API("/onboarding/vendor/${covgId}");
export const vendorOnboardingExportAPI = new API(
  "/onboarding/vendor/${covgId}/export"
);
export const onboardingStatsAPI = new API("onboarding/stats");
export const onboardingMonitorStatusAPI = new API(
  "onboarding/monitor-status/${covgId}"
);

export const resendInviteEmailAPI = new API(
  "onboarding/vendor/${covgId}/email-invitation"
);

//vendor group management
export const covgByIdAPI = new API("/covg/id/${covgId}");
export const covgByCovIdAPI = new API("/covg/covId/${covId}");
export const covgBySignupCodeAPI = new API("/covg/signupCode/${code}");
export const covgByPtidAPI = new API("/covg/ptid/${ptid}");
export const regroupCovgsAPI = new API("/covg/regroup");

//qa apis
export const qaExpireSubscriptionAPI = new API("/qa/subscription-expiration");
export const qaSubscriptionRenewalDateAPI = new API("/qa/${id}/renewal-date");
export const qaRunnablesAPI = new API("/qa/runnables");

//async reports
export const asyncReportsAPI = new API("/asyncReports");

//auth
export const loginAPI = new API("/auth/login");
export const passwordResetAPI = new API("/auth/password-reset");

//feature flags
export const featureFlagsAPI = new API("/feature-flags");
export const featureFlagByIdAPI = new API("/feature-flags/${id}");
